import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class PromptRegisterSessionStorageService {
   private readonly promptOrderingOptionsStorageKey = '__ndt-prompt-ordering-options';

   clearAll(): void {
      localStorage.clear();
   }

   removePromptOrderingOptions(): void {
      localStorage.removeItem(this.promptOrderingOptionsStorageKey);
   }

   getPromptOrderingOptions() {
      const localData = localStorage.getItem(this.promptOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setPromptOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.promptOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
